import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ColorProvider } from '@providers/color/color';
import { Events } from 'ionic-angular';


@Directive({
  selector: '[custom-segment-color]' // Attribute selector
})
export class CustomSegmentColorDirective implements OnChanges {

  @Input('custom-segment-color') options: any;

  constructor(private el: ElementRef, private colorProvider: ColorProvider, private events: Events) {

    this.update();
    
    this.events.subscribe('color:updated', () => {
      this.update();
    });
  }


  ngOnChanges(changes: SimpleChanges): void {
    this.update();
  }

  update() {
    this.colorProvider.getSecundaryColor().then( color => {
      this.el.nativeElement.style.borderColor = color;
      
      if(this.options && this.options.extraCSS) {
  
        const extraCSS = Object.keys(this.options.extraCSS);
  
        for (const property of extraCSS) {
          const value = this.options.extraCSS[property];
          this.el.nativeElement.style[property] = this.replaceAll(value, '{COLOR}', color);
        }
        
      }

    });
  }


  replaceAll(str, find, value) {
    const re = new RegExp(find, 'g');

    return str.replace(re, value);
  }

}



// WEBPACK FOOTER //
// ./src/directives/custom-segment-color/custom-segment-color.ts